import { render, staticRenderFns } from "./new-employees.vue?vue&type=template&id=09fdf7d1&"
import script from "./new-employees.vue?vue&type=script&lang=js&"
export * from "./new-employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports